import { useCallback, useMemo } from 'react';

import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { areasToFlatCollection, isHighwayArea } from '@/modules/floorplanDesign/helpers';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { NumberInput } from '@/modules/common/components/inputs';

export const VehicleLimit = () => {
  const selectedAreas = useReadSelectedAreas();
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const vehicleLimit = useMemo(() => {
    const areas = areasToFlatCollection(selectedAreas);
    if (areas.length !== 1) return;
    const area = areas[0];
    if (!isHighwayArea(area)) return;

    const { vehicleLimit } = area;
    return vehicleLimit;
  }, [selectedAreas]);

  const onChange = useCallback(
    (newValue: number) => {
      const areas = areasToFlatCollection(selectedAreas);
      if (areas.length !== 1) return;
      const area = areas[0];
      if (!isHighwayArea(area)) return;

      if (Number.isNaN(newValue)) {
        return;
      }

      fddmSvc.setPreference('highwayArea.vehicleLimit', Number(newValue) < 0 ? -1 : newValue);

      fddmSvc.updateArea({
        ...area,
        vehicleLimit: Number(newValue) < 0 ? -1 : newValue,
      });
    },
    [fddmSvc, selectedAreas],
  );

  if (vehicleLimit === undefined) return null;

  return (
    <PropertiesLabel i18nkey='interface:properties.highway.vehicles'>
      <NumberInput
        value={vehicleLimit}
        onChange={onChange}
        clearButton={{
          text: 'All',
          value: -1,
        }}
        sx={{ width: '100%', float: 'right' }}
      />
    </PropertiesLabel>
  );
};
